/** @format */

export type OrgData = Readonly<{
    product: string;
    productType: string;
    variant: string;
    productKey: string;
    doctypeKey: string;
    modality: string;
    defaultInfoClass: string;
    version: string;
    // orgData: string;
    // company: string;
    // group: string;
    // swVer: string;
    // uiNo: string;
    // author: string;
    // doctype: string;
    // cDate: string;
    // variantKey: string;

    // languageKey: string;
    // replace: string;
    // language: string;
    // originalLanguage: string;
    // expireDate: string;
    // translator: string;
    // partNo: string;
    // department: string;
}>;

export const initialOrgDataState: OrgData = {
    product: '',
    productType: '',
    variant: '',
    productKey: '',
    doctypeKey: '',
    modality: '',
    defaultInfoClass: '',
    version: '',
};
